export enum TransferStatus {
  Draft = 1,
  Paid = 2,
  TricycleTransfer = 3,
  DocumentVerification = 4,
  ReadyForTrip = 5,
  BoatTransfer = 6,
  ETrikeTransfer = 7,
  Completed = 8,
  Cancelled = 9,
  WaitTricycle = 10
}
